module.exports = __webpack_public_path__ + "img/gamifinnopolis-sport.min.56a4abeb.svg";